export default __webpack_public_path__ + "static/media/loading-img.ecc2ff8d.png";